function fitWindow () {
  
  let docEl = document.documentElement
  let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  let recalc = () => {
    
    let clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (clientWidth > 420) { clientWidth = 375 }
    
    docEl.style.fontSize = 100 * (clientWidth / 375) + 'px'
  }
  if (!document.addEventListener) return
  window.addEventListener(resizeEvt, recalc, false)
  recalc()
}

function setRatio () {
  let ratio = 1
  if (window.devicePixelRatio > 1) ratio = 2
  document.body.className = 'ratio-' + ratio + 'x'
}

export default {
  fitWindow,
  setRatio
}



// WEBPACK FOOTER //
// ./src/screen.js